// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__1ZyY3","Overlay":"Modal_Overlay__2WlfQ"};